import { useReducer, useEffect } from 'react';
import ComponentNotifier from '../../../../services/wss/ComponentNotifier';
import floatingPanelEngine from '../Core/FloatingPanelEngine';

/**
 * Paint trigger for selectedEntry only — used by FloatingContentPanelBody.
 * Separate from useSearchResults so Body does not re-render on every search notify.
 *
 * @param {string} panelId
 * @returns {object|null} selectedEntry
 */
export default function useSelectedEntry(panelId) {
    const [, forceUpdate] = useReducer(x => x + 1, 0);

    useEffect(() => {
        const channel = `SearchResultProvider_${panelId}`;
        const unsub = ComponentNotifier.subscribe(channel, forceUpdate);
        return () => unsub();
    }, [panelId]);

    return floatingPanelEngine.getProvider(panelId)?.getSelectedEntry() ?? null;
}
